import { Component, OnInit } from '@angular/core';
import { BookVersionIntegrationModel, BookVersionModel } from '../../../models/edu-admin/book-version.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CultureModel } from '../../../models/localization-and-pricing/culture.model';
import { AdminBookVersionService } from '../../../services/admin/admin-book-version.service';
import { ModalService } from '../../../shared/modals/modal/modal.service';
import { ErrorModel } from '../../../models/shared/error.model';
@Component({
  selector: 'app-school-book-version-edit',
  templateUrl: './admin-book-version-edit.component.html',
  styleUrls: ['./admin-book-version-edit.component.css']
})
export class AdminBookVersionEditComponent implements OnInit {

  isEditMode = false;
  BookVersion = BookVersionModel;
  version = new BookVersionModel();
  bookId: string;
  CultureModel = CultureModel;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private versionSv: AdminBookVersionService,
    private modalSv: ModalService) { }

  ngOnInit() {

    this.route.params.subscribe((params) => {
      this.bookId = params.bookId;
      const versionId = params.versionId;
      if (versionId) {
        this.isEditMode = true;
        this.versionSv.fetchBookVersionById(this.bookId, versionId).subscribe((bookVersion) => {
          this.version = bookVersion;
          this.version.integrations = this.version.integrations.sort((integrationOne, integrationTwo) => {
            return integrationOne.chapter - integrationTwo.chapter;
          });
        });
      } else {
        this.isEditMode = false;
      }
    });
  }

  getTitle(): string {

    if (this.isEditMode) {
      return 'Save';
    }

    return 'Create';
  }


  getIsPublished(): boolean {

    if (this.version) {

      return this.version.isPublished;
    }

    return false;
  }

  getPublishTitle(): string {

    if (this.version) {

      if (this.version.isPublished === true) {
        return 'Unpublish';
      }

    }

    return 'Publish';
  }

  onCopyVersion() {

    if (this.version && this.isEditMode === true) {

      this.modalSv.showChoiceModal('Warning', 'You are about to copy a book version are you sure you want to proceed?').subscribe((shouldCopy) => {

        if (shouldCopy === true) {

          console.log('version is: ' + this.version._id);
          this.versionSv.copyBookVersion(this.version, this.bookId).subscribe((version) => {
            console.log('copied version: ' + version._id);
            this.modalSv.showChoiceModal('Success', 'Book version was successfully copied. Want to view the copied book version now?').subscribe((viewBook) => {

              if (viewBook) {
                this.router.navigate(['admin', 'books', version.bookId, 'versions', version._id, 'edit']);
              }

            });

          });
        }

      });

    }
  }

  onPublishClicked() {

    if (this.version && this.isEditMode === true) {
      this.version.isPublished = !this.version.isPublished;
      this.versionSv.updateBookVersion(this.version, this.bookId).subscribe((version) => {
        this.version = version;
        this.modalSv.showAlertModal('Success', 'Book pulishing state was successfully changed');
      });
    }

  }

  onIntegrationClicked(integration: BookVersionIntegrationModel) {

    this.router.navigate(['admin', 'books', this.bookId, 'versions', this.version._id, 'integrations', integration._id, 'edit']);

  }

  onCreateIntegrationClicked() {

    this.router.navigate(['admin', 'books', this.bookId, 'versions', this.version._id, 'integrations', 'create']);

  }

  onSave() {
    if (!this.isEditMode) {
      this.versionSv.createBookVersion(this.version, this.bookId).subscribe((version) => {
        this.version = version;
        this.modalSv.showAlertModal('Success', 'You successfully created a book version').subscribe(() => {
          this.router.navigate(['admin', 'books', this.bookId, 'versions', version._id, 'edit']);
        });
      }, (err: ErrorModel) => {
        this.modalSv.showAlertModal('Error', err.message);
      });
    } else {
      this.versionSv.updateBookVersion(this.version, this.bookId).subscribe((bookVersion) => {
        this.version = bookVersion;
        this.modalSv.showAlertModal('Success', 'You have sccessfully update the version');
      });
    }
  }

  onDelete() {
    this.modalSv.showChoiceModal('Warning', 'Are you sure you want to delete this version?').subscribe((response) => {

      if (response) {
        this.versionSv.deleteBookVersion(this.bookId, this.version._id).subscribe((version) => {
          this.router.navigate(['admin', 'books', version.bookId, 'edit']);
        });
      }

    });
  }

}
